module.exports = __webpack_public_path__ + "img/team.497bb359.jpg";